export const LetterTemplates = [
    {
        'title': 'Приветствие студента-квотника',
        'message': `Dear Student!
 
On behalf of Ural Federal University we would like to welcome You at the Preparatory Department for Foreign Students UrFU.
 
Study year at the Preparatory Department starts in September/October. If you plan to study offline you should come to Yekaterinburg as soon as possible considering the time you need to arrange your visa and other documents (but not later than October).  Right now you need to solve the visa issue, the information will be in your personal account of Rossotrudnichestvo (https://russia-edu.minobrnauki.gov.ru/ ) if you don't have an access you can ask us to check this information. With "Направление" visa direction number you need to visit the Embassy of RF to get a visa. 
 
And also we ask you to answer some questions below in English or Russian language:
 
1) Your full name
2) If you have studied Russian before please tell us where and for how long? If you have never studied Russian before then simply state this. 
4) Please indicate your choice for medium of instruction: (A) 100% online via video link like Zoom; (B) 100% Offline in a classroom. But still we recommend studying offline for the best results.
5) Please give us your other contact information such as: additional email, WhatsApp, WeChat, Skype, etc. 
6) Please attach a scanned copy of your passport that shows your passport details including name and photograph.
 
Please, send us the answers via email.
All our communication with the Preparatory Department of UrFU will be via email: rfl@urfu.ru
Please contact us if you need any clarification.
 
Sincerely yours, 
RFL Team
rfl@urfu.ru
С уважением,
Команда Подготовительного отделения`
    },
    {
        'title': 'Приветствие студента-контрактника',
        'message': `Dear applicant,
 
Attached to this letter you will find an official invitation issued by the Ministry of Internal Affairs of the Russian Federation.
You need to print it out and apply to the Consulate of the Russian Federation in the specified city. Please double check if all the details are correct!
 
!!! All students must arrive and register at the university within the first 45 days of the date of entry indicated in the invitation. Otherwise, the University has the right to cancel the invitation through the Migration Service.
 
As prescribed by the Recommendations of the Federal Service for Consumer Rights Protection and Human Wellbeing (on the prevention of new coronavirus infection (COVID-19) in organizations of higher education of July 29, 2020), an incoming international student must take a COVID-19 test not earlier than 48 hours before arrival to Russia and be tested for COVID-19 within the first 48 hours after arrival to Russia.
 
You must notify the Ural Federal University of your arrival at least 10 days in advance:
1.         by filling out the form: https://urfu.ru/en/international/information-for-prospective-international-students/application-information/arrival-form/
2.         by notifying via email: adaptation@urfu.ru
You can find more information about arrival here: https://urfu.ru/index.php?id=26161
 
You can find information on how to get to the university using the link: https://urfu.ru/en/international/information-for-prospective-international-students/first-steps-in-ekaterinburg/
 
For more information on airport pick-up, accommodation and health insurance please contact the International Student Adaptation Centre at adaptation@urfu.ru
 
 
Please, note that the university’s dormitory is out of places, but there is an option to stay in the commercial dormitory or a hostel which can be offered by the student’s union. More information can be found here: https://en.studentrealty.ru/
 
 
The list of documents required on arrival can be found in our before arrival guide here:  https://drive.google.com/drive/folders/1Exkx_9goLZ1Psh-dQx5vNVQRGWe-hjNl
 
General scheme of your actions before your arrival:
 
1)  \tBook a hotel/hostel in advance for you to stay there until you get the university’s dormitory
2)  \tTake a COVID-19 test not later than 48 hours before your flight to Russia
3)  \tTake a COVID-19 test within the first 48 hours after your arrival to Russia
 
Please be aware that the information may change.
 
 
Kindly carefully read all the information attached in PDF files before your arrival to Russia! Both files are located here: https://drive.google.com/drive/folders/1Exkx_9goLZ1Psh-dQx5vNVQRGWe-hjNl
 
We sincerely hope to meet you in person at our university!`
    },
    {
        'title': 'Ответ на письмо квотника с вопросом оформления визы',
        'message': `Study year at the Preparatory Department starts in September/October. If you plan to study offline you should come to Yekaterinburg as soon as possible considering the time you need to arrange your visa and other documents (but not later than October).  Right now you need to solve the visa issue, the information will be in your personal account of Rossotrudnichestvo (https://russia-edu.minobrnauki.gov.ru/ ). If you don't have access you can ask us to check this information. With "Направление" and visa direction number you need to visit the Embassy /  Consulate of RF  to get a visa.`
    },
    {
        'title': 'Ответ на письмо нового слушателя-контрактника (уже есть в контингенте, оплатил всё)',
        'message': `Hello!
 
Please, answer the following questions in English or Russian language:
 
1) Your full name
2) If you have studied Russian language before please tell us where and for how long? If you have never studied Russian before then simply state this. 
3) Please tell us why you wish to study Russian language  (example: for further studies at the University; for work; others). Please also tell us your choice of speciality (example: Language, Physics, Sociology, etc.)
4) Please indicate your choice for medium of instruction: (A) 100% online via video link like Zoom; (B) 100% Offline in a classroom. But still we recommend studying offline for the best results.
5) Please give us your other contact information such as: additional email, WhatsApp, WeChat, Skype, etc.
6) Please attach a scanned copy of your passport that shows your passport details including name and photograph (not translation but original passport).
 
Please contact us if you need any clarification.
 
Best regards,
Preparatory Department team
`
    },
    {
        'title': 'Ответ на письмо нового слушателя-квотника (еще не приехал)',
        'message': `Dear Student!
On behalf of Ural Federal University we would like to welcome You at the Preparatory Department for Foreign Students UrFU.
 
Study year at the Preparatory Department starts in September/October. If you plan to study offline you should come to Yekaterinburg as soon as possible considering the time you need to arrange your visa and other documents (but not later than October).  Right now you need to solve the visa issue, the information will be in your personal account of Rossotrudnichestvo (https://russia-edu.minobrnauki.gov.ru/ ) if you don't have an access you can ask us to check this information. With Направление and visa direction number you need to visit the Embassy of RF to get a visa. 
And also we ask you to answer some questions below in English or Russian language:
 
1) Your full name
2) If you have studied Russian before please tell us where and for how long? If you have never studied Russian before then simply state this. 
3) Please indicate your choice for medium of instruction: (A) 100% online via video link like Zoom; (B) 100% Offline in a classroom. But still we recommend studying offline for the best results.
4) Please give us your other contact information such as: additional email, WhatsApp, WeChat, Skype, etc. 
5) Please attach a scanned copy of your passport that shows your passport details including name and photograph.
 
Please, send us the answers via email.
All our communication with the Preparatory Department of UrFU will be via email: rfl@urfu.ru
Please contact us if you need any clarification.
`
    },
    {
        'title': 'Ответ на письмо о возможности и условиях обучения',
        'message': `Hello! 
To join Preparatory Department of UrFU you need to contact Michayil Kopyrin, who will inform you about the price of the course, contract and visa invitation:
 
Phone number: +7(343)3754689
Adress: И-528, Mira, 19, Ekaterinburg
E-mail: m.e.kopyrin@urfu.ru 
 
After you arrange the contract you will join the lessons.
 
The information is also available here on our site: 
https://rfl.urfu.ru/en/programs-and-courses/
 
___________________________________________________________________________

Добрый день!
 
Чтобы начать обучение на Подготовительном отделении для иностранных учащихся УрФУ, свяжитесь, пожалуйста, с Михаилом Копыриным. Михаил даст вам информацию о стоимости курса, о заключении договора, о визе и приглашении:
 
Телефон: +7(343)3754689
Адрес: И-528, ул. Мира, 19, Екатеринбург
E-mail: m.e.kopyrin@urfu.ru 
 
Также информация есть на нашем сайте:
https://rfl.urfu.ru/en/programs-and-courses/
`
    },
    {
        'title': 'Ответ новому студенту с информацией о входном тестировании',
        'message': `Добро пожаловать в УрФУ!
 
Так как Вы уже изучали русский язык раньше, мы просим Вас пройти небольшой тест по русскому языку (грамматика, чтение, аудирование, письмо). Всю информацию о том, как проходить тест, Вы найдёте в прикрепленных к письму файлах (файл "Письмо о входном тестировании" есть на русском и на английском языке). Результаты этого теста помогут нам подобрать для Вас подходящую учебную группу.
 
Пожалуйста, прочитайте инструкции и пройдите тест.
 
Для тестирования навыков устной речи Вам напишет преподаватель.
 
___________________________________________________________________________
 
Hello,
Welcome to UrFU!
 
As you have already learned Russian, we send you the letter with all the information about the entrance test (grammar, reading, listening, writing - in attached files), which will help us to define your current level. The file "Letter about entrance test" is available in Russian and in English.
 
Please read it and follow the instructions.
 
Your speaking test will take place later. Teacher will contact you via your email!
`
    },
    {
        'title': 'Ответ на вопрос о предметах в профильных группах 2 семестра (для магистра/аспиранта!)',
        'message': `Hello, 
In the next semester there are 5 options to choose your specialization group for your preparatory year before master degree:
 
1) in Economics (Russian language of economics; Russian language of math and statistics; Academic writing; Speciality texts; Economics                                                                                                                                                            ; Economics and statistics)        
2) in Engineering and Technology(Russian language of math & physics; Russian language of IT; Speciality texts; Academic writing)
3) in Humanity Studies (Russian language of the social studies and humanity; Social science; Introduction to speciality; History; Academic writing  
4) in Natural Science (Russian language of physics & chemistry; Academic writing; Physics; Speciality texts; Chemistry) 
5) in Medicine and Biology (Biology; Language of biology; Language of chemistry and physics; Academic writing; Speciality texts) 
  
Please, check the list above. Write to us if you have any other questions about your classes.
`
    },
    {
        'title': 'Рассылка слушателям с большим количеством пропусков занятий - 1 уведомление',
        'message': `Дорогие студенты Подготовительного отделения УрФУ!
 
Надеемся, что с вами всё в порядке, и вы здоровы.
Мы получили информацию от куратора о том, что вы пропустили почти все занятия в первом семестре или не вышли на связь. 
Обращаем ваше внимание, что посещение занятий является обязательным условием для успешного прохождения экзаменов и получения сертификатов по итогам обучения.
И просим вас предоставить причины ваших пропусков в ответном письме.
Если вы не предоставите уважительные причины пропусков и не приступите ближайшее время после получения этого письма к обучению на регулярной основе, то вы будете отчислены с Подготовительного отделения, так как непосещение занятий является нарушением условий заключенного договора.
 
И если у вас есть вопросы, пожалуйста, пишите нам (rfl@urfu.ru) или приходите по адресу Мира, 19, офис И 528 в рабочие часы с 9.00 до 17.00.
 
С наилучшими пожеланиями,
Команда Подготовительного отделения для иностранных учащихся
 
 
 
Dear student of the Preparatory Department for Foreign Students, UrFU!
We have received information from your teacher that you didn’t attend classes and don’t reply emails.
Please note that attending classes is a prerequisite and a mandatory condition for successful exams’ passing and obtaining certificates at the end.
You should provide the reason for your absence in the response letter to rfl@urfu.ru 
If you do not provide a valid reason for your absence and do not start regularly attend the classes within the next week after receiving this letter, then you will be expelled from the Preparatory Department, since not attending classes is a violation of the terms of the concluded agreement and your visa will be cancelled.
 
If you have any questions, please write to us (rfl@urfu.ru) or come to Mira, 19, office I 528 during business hours from 9.00 to 17.00.
 
Best wishes,
Team of the Preparatory Department for Foreign Students
Dear student of the Preparatory Department for Foreign Students, UrFU!
`
    },
    {
        'title': 'Рассылка слушателям с большим количеством пропусков занятий - 2 уведомление',
        'message': `Дорогие студенты Подготовительного отделения УрФУ!
 
К сожалению, мы вынуждены уведомить Вас о Вашем отчислении из УрФУ в ближайшие дни.
От ваших учителей мы получили подтверждение, о том, что вы пропустили почти все занятия в первом семестре или не вышли на связь, несмотря на то, что получили уведомление о планируемом отчислении. 
Обращаем ваше внимание, что посещение занятий является обязательным условием для успешного прохождения экзаменов и получения сертификатов по итогам обучения.
Вы будете отчислены с Подготовительного отделения в ближайшие дни, так как непосещение занятий является нарушением условий заключённого договора. Ваша виза будет аннулирована.
 
С наилучшими пожеланиями,
Команда Подготовительного отделения для иностранных учащихся
 
 
 
Dear student of the Preparatory Department for Foreign Students, UrFU!
 
Unfortunately, we have to inform you about the fact of your disenrollment from Ural Federal University.
We received confirmation from your teacher that you didn't attend classes and didn’t reply emails even after notification about your forthcoming disenrollment.
Please note that attending classes is a prerequisite and a mandatory condition for successful exams’ passing and obtaining certificates at the end.
 
You will be expelled from the Preparatory Department, since not attending classes is a violation of the terms of the concluded agreement and your visa will be cancelled.
 
 
Best wishes,
Team of the Preparatory Department for Foreign Students
Dear student of the Preparatory Department for Foreign Students, UrFU!
`
    },
    {
        'title': 'Уведомление слушателям-контрактникам-должникам',
        'message': `Dear students!
We remind you to pay and provide a photo or scan of the payment receipt to e.e.chaukhan@urfu.ru 
You can pay the fee either in person at any bank office or online at https://ubu.urfu.ru/pay/?locale=en
Your contract payment number is: (заполняется индивидуально)
Sum to be paid: (заполняется индивидуально)
If payment is not made and / or confirmation of payment by the due date is not sent to us, we will be forced to stop your educational process with your subsequent expulsion.
If you have any questions, please contact Ellina Chaukhan by mail: e.e.chaukhan@urfu.ru  or phone number +7 (343) 375-46-89
 
Yours faithfully,
Team of the preparatory department for foreign students
UrFU
`
    }
]